import React, { useContext } from "react";

import { observer } from "mobx-react";

import { BetBuilderPicksOfferTips } from "../BetBuilderPicksOfferTips";

import { OfferStoreContext } from "@gp/components";

import { BetBuilderPick } from "@data-types/bet-booster/BetBuilderPicks";

import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { QuickPlayPopupsTeams } from "@features/quick-play/desktop/common/QuickPlayPopupsTeams";
import QuickPlayEventResultAndTime from "@features/quick-play/shared/QuickPlayEventResultAndTime";

export default observer(function BetBuilderPicksPopupEventBody(props: {
	BBPick: BetBuilderPick;
}) {
	//@ts-expect-error
	const store: AdditionalOfferViewStore | EventViewStore =
		useContext(OfferStoreContext);

	return (
		<div className="card card--qp card--qp--scroll card--bbp u-padd--reset">
			<div className="card__body card--qp__body card--bbp__body">
				<QuickPlayEventResultAndTime
					event={store.event}
					startTime={props.BBPick.startTime}
				/>
				<div className="card--qp__event card--bbp__event">
					<QuickPlayPopupsTeams
						sportData={props.BBPick.multiOffers[0].sportData}
						eventId={props.BBPick.eventId}
						sportId={props.BBPick.sportId}
						isLinkDisabled
						isBetBuilder
					/>
				</div>
				<div className="card--qp__offer card--bbp__offer">
					<BetBuilderPicksOfferTips
						multiOffers={props.BBPick.multiOffers}
						isWrapped={true}
					/>
				</div>
			</div>
		</div>
	);
});
